import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  // Check if already logged in
  useEffect(() => {
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    if (isLoggedIn === 'true') {
      navigate('/');
      return;
    }
    
    const isAdminLoggedIn = sessionStorage.getItem('isAdminLoggedIn');
    if (isAdminLoggedIn === 'true') {
      navigate('/admin');
    }
  }, [navigate]);

  const handleLogin = (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // Simulate login delay
    setTimeout(() => {
      // Normal school login credentials
      if (username === 'misinternational' && password === '2208') {
        localStorage.setItem('isLoggedIn', 'true');
        if (rememberMe) {
          localStorage.setItem('rememberMe', 'true');
        } else {
          localStorage.removeItem('rememberMe');
        }
        setLoading(false);
        navigate('/');
        return;
      }
      
      // Admin login credentials
      if (username === 'aisha2208' && password === '9519800964ali') {
        sessionStorage.setItem('isAdminLoggedIn', 'true');
        setLoading(false);
        navigate('/admin');
        return;
      }
      
      // Invalid credentials
      setError('Invalid Username or Password');
      setLoading(false);
    }, 800);
  };

  return (
    <div style={styles.container}>
      <div style={styles.loginBox}>
        <div style={styles.logoContainer}>
          <div style={styles.logoPlaceholder}>🏫</div>
          <h1 style={styles.schoolName}>MIS International School</h1>
          <p style={styles.subtitle}>School Timetable & Teacher Arrangement Management System</p>
        </div>

        <form onSubmit={handleLogin} style={styles.form}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              style={styles.input}
              placeholder="Enter your username"
              required
            />
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}>Password</label>
            <div style={styles.passwordWrapper}>
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={styles.passwordInput}
                placeholder="Enter your password"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={styles.showPasswordBtn}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? '🙈' : '👁️'}
              </button>
            </div>
          </div>

          <div style={styles.optionsRow}>
            <label style={styles.checkboxLabel}>
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                style={styles.checkbox}
              />
              Remember Me
            </label>
          </div>

          {error && <div style={styles.errorMessage}>{error}</div>}

          <button
            type="submit"
            style={styles.loginButton}
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div style={styles.footer}>
          <p style={styles.footerText}>Powered by Jauhari WebTech</p>
          <p style={styles.footerText}>© 2026 Jauhari WebTech. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #0a1e3c 0%, #1a3a6b 100%)',
    padding: '20px',
  },
  loginBox: {
    backgroundColor: 'white',
    borderRadius: '20px',
    padding: '40px 30px',
    maxWidth: '420px',
    width: '100%',
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
  },
  logoContainer: {
    textAlign: 'center',
    marginBottom: '30px',
  },
  logoPlaceholder: {
    fontSize: '64px',
    marginBottom: '10px',
  },
  schoolName: {
    fontSize: '1.5rem',
    fontWeight: '700',
    color: '#0a1e3c',
    margin: '0 0 8px 0',
  },
  subtitle: {
    fontSize: '0.85rem',
    color: '#666',
    margin: 0,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '18px',
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  label: {
    fontSize: '0.9rem',
    fontWeight: '500',
    color: '#1f3a6b',
  },
  input: {
    padding: '12px 16px',
    borderRadius: '10px',
    border: '2px solid #e2e9f2',
    fontSize: '1rem',
    outline: 'none',
    transition: '0.2s',
    width: '100%',
    boxSizing: 'border-box',
  },
  passwordWrapper: {
    position: 'relative',
    width: '100%',
  },
  passwordInput: {
    padding: '12px 16px',
    paddingRight: '50px',
    borderRadius: '10px',
    border: '2px solid #e2e9f2',
    fontSize: '1rem',
    outline: 'none',
    transition: '0.2s',
    width: '100%',
    boxSizing: 'border-box',
  },
  showPasswordBtn: {
    position: 'absolute',
    right: '12px',
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'none',
    border: 'none',
    fontSize: '1.2rem',
    cursor: 'pointer',
    padding: '4px',
  },
  optionsRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  checkboxLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '0.9rem',
    color: '#1f3a6b',
    cursor: 'pointer',
  },
  checkbox: {
    width: '18px',
    height: '18px',
    cursor: 'pointer',
  },
  errorMessage: {
    backgroundColor: '#fee2e2',
    color: '#dc2626',
    padding: '10px 14px',
    borderRadius: '8px',
    fontSize: '0.9rem',
    textAlign: 'center',
  },
  loginButton: {
    padding: '14px',
    backgroundColor: '#0a1e3c',
    color: 'white',
    border: 'none',
    borderRadius: '10px',
    fontSize: '1.1rem',
    fontWeight: '600',
    cursor: 'pointer',
    transition: '0.2s',
    marginTop: '4px',
  },
  footer: {
    marginTop: '30px',
    paddingTop: '20px',
    borderTop: '1px solid #eef2f7',
    textAlign: 'center',
  },
  footerText: {
    fontSize: '0.75rem',
    color: '#999',
    margin: '4px 0',
  },
};

export default Login;